import { createSlice } from "@reduxjs/toolkit";
import { actionTypes } from "../../../Auth/_redux/authRedux";

const initialListingsState = {
  activeTab: 0,
};

export const liveInteractionsSlice = createSlice({
  name: "liveInteractionsSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
  },
  reducers: {
    setLiveInteractionPageTabIndex: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

export const { setLiveInteractionPageTabIndex } = liveInteractionsSlice.actions;
